export default __webpack_public_path__ + "media/images/Icon-feather-message-circle-700a272d6135e46512c5f60352b93777.svg";